import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { CrewGroup } from '../core/entities/entity-model';
import { MessageService } from '../core/message.service';
import { VaderoTankUnitOfWorkService } from '../core/vadero-tank-unit-of-work.service';

@Component({
        selector: 'crewgroup',
    templateUrl: 'crewgroup.component.html'
})
export class CrewGroupComponent implements OnInit {
    crewGroup: CrewGroup = new CrewGroup();
    crewGroupId: string;
    crewGroupForm: FormGroup;

    constructor(private formBuilder: FormBuilder, private unitOfWork: VaderoTankUnitOfWorkService
        , private route: ActivatedRoute, private router: Router
        , private messageService: MessageService) {
        this.crewGroupForm = this.formBuilder.group({
            'name': [null, Validators.required]
        });
    }

    ngOnInit() {
        this.route.params
            .subscribe(params => {
                if (params['id']) {
                    this.unitOfWork.crewGroupRepo.withId(params['id'])
                        .subscribe(group => {
                            let test = 'test';
                            this.crewGroup = group;
                        });
                }
                else {
                    this.crewGroup = this.unitOfWork.createCrewGroupFactory().create();
                }
            });
    }

    saveChanges() {
        this.unitOfWork.commit().catch(
            error => {
                this.messageService.displayMessage('Error', 'Error saving crew group');
            }
        ).then(response => {
                this.router.navigate(['/sysadmin/crewgroups']);
            });
    }

    cancel() {
        this.unitOfWork.rollback();
        this.router.navigate(['/sysadmin/crewgroups']);
    }
}
